import React, { useEffect } from 'react';

const WorkflowRules = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: WorkflowRules is not implemented yet.');
  }, []);
  return (
    <>
  { /*WorkflowRules */} 
 </>
  );
};

export default WorkflowRules;
